import {CSSTransition} from 'react-transition-group';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import './FadeInTransition.css';

import isInternetExplorer from '../../utils/ie';

class FadeInTransition extends Component {
    static propTypes = {
        children: PropTypes.any
    };

    static defaultProps = {
        children: undefined
    }

    constructor(props) {
        super(props);
        this.nodeRef = React.createRef();
    }

    renderEmptyContent() {
        return (<span>{this.props.children}</span>);
    }

    renderTransitionContent() {
        return (
            <CSSTransition
                in
                appear
                classNames="fadeIn"
                timeout={200}
                nodeRef={this.nodeRef}
            >
                <div ref={this.nodeRef} className="fadeIn-wrapper">{this.props.children}</div>
            </CSSTransition>
        );
    }

    render() {
        return (
            isInternetExplorer ? this.renderEmptyContent() : this.renderTransitionContent()
        );
    }
}
export default FadeInTransition;
